import React from 'react';
import Button from 'ui/elements/buttons/Button';
import { SimpleLabel } from 'types/company/company';
import AddIcon from 'ui/elements/icons/AddIcon';
import { bluePlanetTheme } from 'ui/theme';
import LabelEditor from './LabelEditor';

interface LabelEditorProps {
  labels: SimpleLabel[];
  renderLabel: (label: SimpleLabel) => React.ReactNode;
  onChange: (labels: SimpleLabel[]) => void;
}

export function EditLabels({ labels, renderLabel, onChange }: LabelEditorProps) {
  const addEmptyLabel = () => {
    const newLabel: SimpleLabel = {
      name: '',
      color: bluePlanetTheme.bluePlanetPalette.blue.medium,
    };
    onChange([...labels, newLabel]);
  };

  const removeLabel = (index: number) => {
    onChange(labels.filter((_, i) => i !== index));
  };

  const updateLabel = (index: number, updates: Partial<SimpleLabel>) => {
    onChange(labels.map((label, i) => (i === index ? { ...label, ...updates } : label)));
  };

  return (
    <div className="u-flex u-flex--column u-flex--gap-1">
      {labels.map((label, index) => (
        <LabelEditor
          key={index}
          label={label}
          index={index}
          onUpdate={updateLabel}
          onRemove={removeLabel}
          renderLabel={renderLabel}
        />
      ))}
      <div>
        <Button kind="tertiary" onClick={addEmptyLabel}>
          <AddIcon fontSize="small" className="u-quarter-spacing-right" />
          Add Label
        </Button>
      </div>
    </div>
  );
}
